import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthorizationState } from "./types";
import { LoginResponse } from "../models";
import { ErrorData } from "../../core/http/types";

interface IAuthState {
	current: AuthorizationState;
	token?: string;
}

const initialState: IAuthState = {
	current: { status: "init" },
};

const name = "auth";


const reportsSlice = createSlice({
	name,
	initialState,
	reducers: {
		successfulLogin: (state, action: PayloadAction<LoginResponse>) => ({
			...state,
			current: {
				status: "successful",
				user: action.payload.uData,
			},
		}),
		failedLogin: (state, action: PayloadAction<ErrorData>) => ({
			...state,
			current: {
				status: "failed",
				error: action.payload,
			},
		}),
		resetLoginState: state => ({
			...state,
			current: {
				status: "init",
			},
		}),
		setPendingLoginState: state => ({
			...state,
			current: {
				status: "pending",
			},
		}),
		setToken: (state, action: PayloadAction<string | undefined>) => ({
			...state,
			token: action.payload
		}),
		removeToken: (state, action: PayloadAction<string | undefined>) => ({
			...state,
			token: undefined
		}),
	},
});

export const { successfulLogin, failedLogin, resetLoginState, setPendingLoginState, setToken, removeToken } = reportsSlice.actions;

export default reportsSlice.reducer;
